<template>
	<div class="footer">
		<p>
			抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防上当受骗，适度游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活。</p>
		<p>游戏隐私政策及儿童个人信息保护规则 2023-2024 网络游戏行业防沉迷自律公约</p>
		<p>Copyright ©2023-2024 All Rights Reserved</p>
		<p>备案号：<a href="https://beian.miit.gov.cn/" target="_blank">{{ globalStore.siteSettings.icp }}</a>
		</p>
		<div class="img-box">
			<img src="@/assets/images/footer_img1.png" alt="">
			<img src="@/assets/images/footer_img2.png" alt="">
		</div>
	</div>
</template>
<script setup>
import {useGlobalStore} from '@/pinia'

const globalStore = useGlobalStore()
</script>
<style lang="scss" scoped>
.footer {
	text-align: center;

	p, a {
		font-size: 14px;
		color: #ccc8c5;
		text-decoration: none;
	}

	&:after {
		content: "";
		position: absolute;
		width: 100%;
		height: 10px;
		background: url(@/assets/images/footer_img.png);
		top: -10px;
		left: 0;
		background-size: auto 100%;
	}

	.img-box {
		display: flex;
		justify-content: center;

		img {
			margin: 0 20px;
		}
	}
}
</style>/
